<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Attestation et serment d'office</legend>
        <v-checkbox v-model="AttestationVeracite.identiteEtRenseignements"
                    :rules="rules.identiteEtRenseignements"
                    color="primary"
                    hide-details
                    required>
          <template v-slot:label>
            <div class="ml-5">
              Je certifie que je suis bien <strong>{{ nomDuDemandant }}</strong> ou son représentant légal et que tous
              les renseignements indiqués sur ce formulaire électronique sont exacts et complets.
            </div>
          </template>
        </v-checkbox>
        <section>
          <v-checkbox v-model="AttestationVeracite.validiteDocuments"
                      :rules="rules.validiteDocuments"
                      color="primary"
                      hide-details
                      required>
            <template v-slot:label>
              <div class="ml-5">
                Je certifie que les documents fournis sont valides et authentiques.
              </div>
            </template>
          </v-checkbox>
          <v-checkbox v-model="AttestationVeracite.fausseDeclaration"
                      :rules="rules.fausseDeclaration"
                      color="primary"
                      hide-details
                      required>
            <template v-slot:label>
              <div class="ml-5">
                Je comprends que toute fausse déclaration de ma part entraîne le rejet immédiat de ma demande et qu'une
                demande acceptée sous de fausses déclarations devient nulle.
              </div>
            </template>
          </v-checkbox>
          <v-checkbox v-model="AttestationVeracite.modaliteDemandeAdmission"
                      :rules="rules.modaliteDemandeAdmission"
                      color="primary"
                      hide-details
                      required>
            <template v-slot:label>
              <div class="ml-5">
                En déposant ma demande d'admission, j'affirme avoir pris connaissance des modalités et frais relatifs à
                ma demande d'admission et avoir consulté la FAQ ADMISSION et perfectionnement.  
              </div>
            </template>
          </v-checkbox>
        </section>
      </fieldset>
      <!-- Conditionel a Autorisation de Pratique - Autorisation special -->
      <fieldset v-if="hasAutorisationSpecial">
        <legend class="text-h6 text-sm-h5">Autorisation spéciale</legend>
        <div>
          <v-checkbox v-model="AttestationVeracite.exercerAuxConditionsEtNormes"
                      :rules="rules.exercerAuxConditionsEtNormes"
                      color="primary"
                      hide-details
                      required>
            <template v-slot:label>
              <div class="ml-5">
                <p>
                  JE M'ENGAGE À :
                </p>
                <ol class="c" style="margin-left:16px;">
                  <li>Exercer aux conditions et modalités prévues par l'autorisation spéciale.</li>
                  <li>Porter le titre de T.S. et d'exercer les activités réservées autorisées pour la durée mentionnée
                    par l'autorisation spéciale
                  </li>
                  <li>Me conformer aux normes de pratique et au code de déontologie de la profession.</li>
                </ol>
              </div>
            </template>
          </v-checkbox>
        </div>
      </fieldset>
      <!-- Conditinel a Autorisation de Pratique - Etudiant -->
      <fieldset v-if="isStudent">
        <legend class="text-h6 text-sm-h5">Étudiant</legend>
        <v-checkbox v-model="AttestationVeracite.contactEtablissementEtSuperviseur"
                    :rules="rules.contactEtablissementEtSuperviseur"
                    color="primary"
                    hide-details
                    required>
          <template v-slot:label>
            <div class="ml-5">
              J'autorise mon établissement d'enseignement responsable du programme auquel j'ai été admis(e) à informer
              l'Ordre des changements à mon statut d'étudiant(e), ainsi qu'à mes renseignements personnels notés à la
              section « identification ». J'autorise l'Ordre à communiquer avec mon superviseur au besoin.
            </div>
          </template>
        </v-checkbox>
      </fieldset>
      <!-- Conditinel a Autorisation de Pratique - Mediateur familiale -->
      <fieldset v-if="isMediateur">
        <legend class="text-h6 text-sm-h5">Médiation avec engagement ou Réactivation</legend>
        <div>
          <v-checkbox v-model="AttestationVeracite.suivreFormations"
                      :rules="rules.suivreFormations"
                      color="primary"
                      hide-details
                      required>
            <template v-slot:label>
              <div class="ml-5">
                <p>
                  Je m'engage à suivre les 45 h de formation complémentaire requise pour rencontrer les exigences du
                  Règlement et consistant en un approfondissement des mêmes sujets que la formation de base (sujets
                  reliés à la séparation, au divorce ou à la nullité du mariage), soit :
                </p>
                <ol class="c" style="margin-left:16px;">
                  <li>15 h de processus de médiation</li>
                  ET
                  <li>pour les non-juristes : 30 h sur les aspects économiques, égaux et fiscaux</li>
                </ol>
                Je m'engage à
                <ol class="c" style="margin-left:16px;">
                  <li>compléter deux mandats de médiation globale (comportant quatre objets et au moins quatre séances
                    de supervision en cours de mandat)
                  </li>
                  <li>compléter trois mandats de médiation (comportant au moins trois séances de supervision en cours de
                    mandat)
                  </li>
                  <li>compléter cinq mandats de médiation (comportant au moins une séance de supervision en cours de
                    mandat)
                  </li>
                  <li>que parmi les mandats supervisés soumis, au moins cinq se soient terminés par une entente portant
                    sur tous les objets et, pour ces mandats, avoir traité au moins deux fois les quatre objets de la
                    médiation
                  </li>
                </ol>
              </div>
            </template>
          </v-checkbox>
        </div>
      </fieldset>
    </v-form>
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid || !requiredFieldSelected" color="secondary" @click="saveAndContinueLater()">Enregistrer
        et terminer plus tard
      </v-btn>
      <v-btn :disabled="!valid || !requiredFieldSelected" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Loader from "../Loader"
import { isDroitsAcquis } from "@/utils/autorisationHelper"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin"

export default {
  mixins: [
    NavigationPageFormulaireMixin,
    PageReadonlyFormulaireAdmissionMixin
  ],
  props: {
    routeName: {
      type: String,
      default: ''
    },
  },
  components: {
    Loader: Loader
  },
  data () {
    return {
      overlay: false,
      valid: true,
      typeAutre: [],
      rules: {
        modaliteDemandeAdmission: [(v) => !!v || "Vous devez accepter ces termes"],
        identiteEtRenseignements: [(v) => !!v || "Vous devez accepter ces termes"],
        validiteDocuments: [(v) => !!v || "Vous devez accepter ces termes"],
        fausseDeclaration: [(v) => !!v || "Vous devez accepter ces termes"],
        exercerAuxConditionsEtNormes: [(v) => !!v || "Vous devez accepter ces termes"],
        contactEtablissementEtSuperviseur: [(v) => !!v || "Vous devez accepter ces termes"],
        suivreFormations: [(v) => !!v || "Vous devez accepter ces termes"],
      },
      messageSelector: "",
    }
  },
  computed: {
    ...mapGetters({
      AttestationVeracite: "AttestationVeracites/GET_ATTESTATIONSVERACITES",
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      demandeAdmissionPpId: "DemandeAdmission/GET_CONTACTID",
      getAutorisation: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
      getFormations: "FormationInitiale/GET_FORMATIONS",
      renseignementsGeneraux: "RenseignementsGeneraux/getRenseignementsGeneraux",
    }),
    hasAutorisationSpecial: function () {
      return this.getAutorisation.find(a => a.categorieAutorisation.id == this.$catalogues.categorieAutorisation.autorisationSpeciale) || this.getFormations.find(f => f.formationUniversitaireEnTravailSocial.id == 8576)
    },
    isStudent: function () {
      return this.getAutorisation.find(a => a.categorieAutorisation.id == this.$catalogues.categorieAutorisation.registreDesEtudiants)
    },
    isMediateur: function () {
      return this.getAutorisation.find(a => a.categorieAutorisation.id == this.$catalogues.categorieAutorisation.mediateurFamilial)
    },
    requiredFieldSelected: function () {
      let result = false

      result = (this.isDroitsAcquis && this.AttestationVeracite.identiteEtRenseignements) || (this.AttestationVeracite.identiteEtRenseignements && this.AttestationVeracite.validiteDocuments && this.AttestationVeracite.fausseDeclaration)

      if (this.hasAutorisationSpecial && result == true) {
        result = this.AttestationVeracite.exercerAuxConditionsEtNormes
      }

      if (this.isStudent && result == true) {
        result = this.AttestationVeracite.contactEtablissementEtSuperviseur
      }

      if (this.isMediateur) {
        result = this.AttestationVeracite.suivreFormations
      }

      return result
    },
    nomDuDemandant: function () {
      return this.renseignementsGeneraux.firstName + " " + this.renseignementsGeneraux.lastName
    },
    isDroitsAcquis () {
      return isDroitsAcquis(this.getAutorisation)
    },
  },
  created () {
    this.fetchItems()
  },
  methods: {
    ...mapActions({
      getAttestationVeracitesByContactId: "AttestationVeracites/getAttestationsVeracitesByContactId",
      updateAttestationVeracites: "AttestationVeracites/updateAttestationsVeracites",
      createAttestationVeracites: "AttestationVeracites/createAttestationsVeracites",
      getAttestationVeracitesByDemandeAdmissionId: "AttestationVeracites/getAttestationsVeracitesByDemandeAdmissionId",
    }),
    async fetchItems () {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        if (this.demandeAdmissionId) {
          await this.getAttestationVeracitesByDemandeAdmissionId(this.demandeAdmissionId)
        } else if (this.demandeAdmissionPpId) {
          await this.getAttestationVeracitesByContactId(this.demandeAdmissionPpId)
        }

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    async save () {
      this.$refs.form.validate()
      if (this.valid && this.AttestationVeracite && this.requiredFieldSelected) {
        this.messageSelector = "Creation"
        this.overlay = true
        if (this.demandeAdmissionId) {
          this.AttestationVeracite.demandeAdmission = this.demandeAdmissionId
        }

        if (this.demandeAdmissionPpId) {
          this.AttestationVeracite.pp = this.demandeAdmissionPpId
        }

        if (!this.AttestationVeracite.id || this.AttestationVeracite.id == 0) {
          this.createAttestationVeracites(this.AttestationVeracite)
              .then((result) => {
              })
              .finally(() => {
                this.overlay = false
                this.redirect()
              })
        } else {
          this.updateAttestationVeracites(this.AttestationVeracite)
              .then((result) => {
              })
              .finally(() => {
                this.overlay = false
                this.redirect()
              })
        }
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item,
  }
}
</script>

<style>
</style>